import { computed, ref, Ref } from 'vue'
import { EmployeeID } from '../../employees/models/employee'
import { Area } from '../../areas/models/area'
import { Skill } from '../../skills/models/skill'
import { Building } from '../../buildings/models/building'

export type ShiftConflictDialogState = {
    area: Area | null
    building: Building | null
    employeeId: EmployeeID | null
    skill: Skill | null
    visible: boolean
}

const state: Ref<ShiftConflictDialogState> = ref({
    area: null,
    building: null,
    employeeId: null,
    skill: null,
    visible: false,
})

export function useShiftConflictDialog() {
    const showAreaConflict = (data: { employeeId: EmployeeID, area: Area }) => {
        state.value = {
            area: data.area,
            building: null,
            employeeId: data.employeeId,
            skill: null,
            visible: true,
        }
    }

    const showBuildingConflict = (data: { employeeId: EmployeeID, building: Building }) => {
        state.value = {
            area: null,
            building: data.building,
            employeeId: data.employeeId,
            skill: null,
            visible: true,
        }
    }

    const showSkillConflict = (data: { employeeId: EmployeeID, skill: Skill }) => {
        state.value = {
            area: null,
            building: null,
            employeeId: data.employeeId,
            skill: data.skill,
            visible: true,
        }
    }

    const hide = () => {
        state.value = {
            area: null,
            building: null,
            employeeId: null,
            skill: null,
            visible: false,
        }
    }

    const isShown = computed(() => state.value.visible && (state.value.employeeId !== null) && (state.value.area !== null || state.value.building !== null || state.value.skill !== null))

    const area = computed(() => state.value.area)
    const building = computed(() => state.value.building)
    const employeeId = computed(() => state.value.employeeId)
    const skill = computed(() => state.value.skill)

    return {
        showAreaConflict,
        showBuildingConflict,
        showSkillConflict,
        hide,
        isShown,
        area,
        building,
        employeeId,
        skill,
    }
}